import { Modal } from "react-bootstrap";
import crossBlack from "../../../assets/images/onboardingImages/crossBlack.svg";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import CheckIcon from "../../../assets/images/greenCheck.svg";
import "./subscribedInfoModal.css";
import { useLocation, useNavigate } from "react-router-dom";
import { showNotificationToast, toastify } from "../../../helpers/toast/toastify";
import { useDispatch, useSelector } from "react-redux";
import { resetOnBoardingStartContext } from "../../../redux/users/usersSlice";

const SubscribedInfoModal = ({ setdisplaySubscribedModal }) => {
  const location = useLocation();
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext
  );
  const { user } = useSelector((state) => state.user);
  const viewOnBlockchainParams = (
    user?.leaderCommunity?.name ? user?.leaderCommunity.name : user?.tradeName
  )
    ?.split(" ")
    ?.join("_");
  const frequency = user?.verifiedmyTrade?.subscription?.frequency;
  const verifiedTradesUrl = viewOnBlockchainParams
    ? `dev.copyyy.it/verifiedTrades/${viewOnBlockchainParams}`
    : "dev.copyyy.it/verifiedTrades";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal subscribedInfoModal"
        show={true}
      >
        <Modal.Body className="subscribedInfoModalBody figma-drop-shadow">
          <button
            className="CrossIcon"
            type="button"
            onClick={() => {
              showNotificationToast("Verifying your trades now!", "Your trading is now being verified.You'll get a link each time it's updated on-chain.\n\nUpgrade your subscription for more frequent updates.");
              
              if (onBoardingStartContext) {
                dispatch(resetOnBoardingStartContext());
                navigate(onBoardingStartContext, { replace: true });
                // if (location.pathname.includes("verifymyTrade")) {
                //   toastify("Awesome! You’re now verifying your performance.");
                // }
                return;
              }
              setdisplaySubscribedModal(false);
            }}
          >
            <img alt="crossBlack" src={crossBlack} />
          </button>

          <div className="subscribedInfoContent">
            <h2 className="title">You’re now subscribed</h2>
            <p className="desc">
              Your performance is now auto-tracked and stored on the blockchain.
            </p>

            <ul className="infoList">
              <li>
                <span className="checkmark">
                  <img src={CheckIcon} alt="CheckIcon" />
                </span>
                Every {frequency === "daily" ? "day" : "month"} you’ll receive a link to the verified trade.
              </li>
              <li>
                <span className="checkmark">
                  <img src={CheckIcon} alt="CheckIcon" />
                </span>
                <span className="infoText">
                  Public page with your verifications:
                  <br />
                  <a
                    className="infoLink"
                    href={`https://${verifiedTradesUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {verifiedTradesUrl}
                  </a>
                  <br />
                  (Link also available on your dashboard)
                </span>
              </li>
              <li>
                <span className="checkmark">
                  <img src={CheckIcon} alt="CheckIcon" />
                </span>
                We recommend
                verifying performance for at least 3 consecutive months for
                accuracy.
              </li>
            </ul>
          </div>
          <div className="d-sm-flex justify-content-center align-items-center flex-column">
            <BubbleSvgButton
              className="NextBtn"
              text={"Ok, got it"}
              type="button"
              variant="green"
              containerStyling={{
                justifyContent: "center",
              }}
              onClick={() => {
               showNotificationToast("Verifying your trades now!", "Your trading is now being verified.You'll get a link each time it's updated on-chain.\n\nUpgrade your subscription for more frequent updates.");

                if (onBoardingStartContext) {
                dispatch(resetOnBoardingStartContext());
                navigate(onBoardingStartContext, { replace: true });
                // if (location.pathname.includes("verifymyTrade")) {
                //   toastify("Awesome! You’re now verifying your performance.");
                // }
                return;
              }
                setdisplaySubscribedModal(false);
              
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SubscribedInfoModal;
